import { useState } from "react";
import { UserPlus, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import InviteOrgMemberModal from "@/components/admin/settings/InviteOrgMemberModal";

interface Step6Props {
  orgId: string;
}

// Reuses the existing InviteOrgMemberModal so an admin can invite a first team
// member without leaving the wizard. Entirely skippable — inviting is optional
// and never blocks completion.
const OrgOnboardingStep6 = ({ orgId }: Step6Props) => {
  const [inviteOpen, setInviteOpen] = useState(false);
  const [invited, setInvited] = useState(false);

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-border p-6 text-center space-y-4">
        <div className="w-14 h-14 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
          {invited ? (
            <Check className="h-7 w-7 text-success" />
          ) : (
            <UserPlus className="h-7 w-7 text-primary" />
          )}
        </div>
        <p className="text-sm text-muted-foreground max-w-sm mx-auto">
          {invited
            ? "Invitation sent. Invite more teammates or continue to finish."
            : "Bring a colleague on board so they can help manage your story and posts."}
        </p>
        <Button variant="outline" className="gap-2" onClick={() => setInviteOpen(true)}>
          <UserPlus className="h-4 w-4" />
          {invited ? "Invite another" : "Invite a team member"}
        </Button>
      </div>

      <InviteOrgMemberModal
        open={inviteOpen}
        onOpenChange={setInviteOpen}
        orgId={orgId}
        onSuccess={() => setInvited(true)}
        canAssignRole={["admin", "editor"]}
      />
    </div>
  );
};

export default OrgOnboardingStep6;
